import styled from 'styled-components';
import { StyleColor, NewStyleColor, Format, BaseStyledComponentProps } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';
import { MenuPosition } from '../../typings/menu';

interface StyledMenuItemProps {
	hasSeparator?: boolean;
}

interface StyledMenuProps extends BaseStyledComponentProps {
	hide: boolean;
	position?: MenuPosition;
}

interface StyledMenuButtonProps extends BaseStyledComponentProps {
	isActive?: boolean;
}

const StyledMenu = styled('ul')`
	position: absolute;
	z-index: 10;
	top: calc(100% + 10px);
	left: ${({ position }: StyledMenuProps) => position === MenuPosition.right ? 'auto' : 0};
	right: ${({ position }: StyledMenuProps) => position === MenuPosition.right ? 0 : 'auto'};
	max-height: 260px;
	width: 340px;
	border-radius: 6px;
	background-color: ${StyleColor.White};
	box-shadow: 0 3px 30px 0 ${hexToRgba(StyleColor.Black, 10)};
	overflow-y: auto;
	list-style-type: none;
	margin: 0;
	padding: 0;
	transition: max-height, opacity 100ms;

	${({ hide }: StyledMenuProps) => hide && `max-height: 0; opacity: 0; pointer-events: none`}

	@media ${Format.SmallSmartphonePortrait} {
		width: 280px;
	}

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }: StyledMenuProps) => theme.primary.actionColor};
		border-radius: 2px;
	}
`;

const StyledMenuButton = styled('button')`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	margin: 0;
	padding: 20px 20px 20px 45px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 17px;
	background-color: ${({ isActive, theme }: StyledMenuButtonProps) => isActive
		? hexToRgba(theme.primary.actionColor, 20)
		: StyleColor.White
	};
	color: ${({ isActive, theme }: StyledMenuButtonProps) => isActive
		? theme.primary.actionColor
		: NewStyleColor.Grey800
	};
	text-align: left;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }: StyledMenuButtonProps) => hexToRgba(theme.primary.actionColor, 20)};
		color: ${({ theme }: StyledMenuButtonProps) => theme.primary.actionColor};
	}

	svg {
		position: absolute;
		top: 50%;
		left: 10px;
		width: 24px;
		height: 24px;
		fill: ${({ theme }: StyledMenuButtonProps) => theme.primary.actionColor};
		transform: translateY(-50%);
	}
`;

const StyledMenuItem = styled('li')`
	${(props: StyledMenuItemProps) => props.hasSeparator && `border-bottom: 1px solid ${StyleColor.Grey100}`}
	word-wrap: break-word;

	&:first-of-type ${StyledMenuButton} {
		border-radius: 6px 6px 0 0;
	}

	&:last-of-type ${StyledMenuButton} {
		border-radius: 0 0 6px 6px;
	}
`;

export {
	StyledMenu,
	StyledMenuItem,
	StyledMenuButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DropdownMenu/styles.ts